<template>
     <div style="width:1300px;margin:0 auto;">
                <div style="margin-top:30px;" class="mb-5">
                    <b-card title="Card Title" no-body>
                 <b-card-header header-tag="nav">
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                       <div style="display:flex;">
                            <b-nav-item @click="day()" :class="{activev:show==1}">昨天</b-nav-item>
                            <b-nav-item @click="mounth()" :class="{activev:show==2}">当月</b-nav-item>
                            <b-nav-item @click="year()" :class="{activev:show==3}">当年</b-nav-item>
                       </div>
                       
                 </b-card-header>

                <b-card-body class="text-center">
                <!-- 第一列 -->
                <div style="display:flex;justify-content: space-around;">
                <div style="width:600px;">
                 <!-- 排行榜1 -->
                                <div>
                                    <img src="../../static/images/huayuanlogo.png" alt="">
                                </div>
                            <div style="width:300px;" class="pai-center">
                                <span class="icon-left"></span>
                                    <h1 class="icon-center">产品销售排行榜</h1>
                                <span class="icon-right"></span>
                                
                            </div>
                                        <div class="content-header"> 
                                                <div class="rank">排名</div>
                                                <div class="hot-product">产品名称</div>
                                                <div class="hot-productNo">药品编号</div>
                                                <div class="hot-amount">销售金额</div>
                                        </div>
                            <div class="brand-content-wrapper">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in tableData1" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{item.rowIndex}}
                                                     </span>
                                                </div>
                                                <div class="hot-product">{{item.drugName}}</div>
                                                <div class="hot-productNo">{{item.drugNo}}</div>
                                                <div class="hot-amount hot-shuliang">{{item.amount}}</div>
                                        </div>
                            </div>
                </div>
                   <div style="width:600px;">
                 <!-- 排行榜2 -->
                                 <div>
                                    <img src="../../static/images/huayuanlogo.png" alt="">
                                </div>
                             <div style="width:300px;" class="pai-center">
                                <span class="icon-left"></span>
                                    <h1 class="icon-center">供应商销售排行榜</h1>
                                <span class="icon-right"></span>
                            </div>
                                        <div class="content-header"> 
                                                <div class="rank">排名</div>
                                                <div class="hot-product">供应商名称</div>
                                                <div class="hot-productNo">供应商编号</div>
                                                <div class="hot-amount">销售金额</div>
                                        </div>
                            <div class="brand-content-wrapper">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in tableData2" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{item.rowIndex}}
                                                     </span>
                                                </div>
                                                <div class="hot-product">{{item.supplierName}}</div>
                                                <div class="hot-productNo">{{item.supplierNo}}</div>
                                                <div class="hot-amount hot-shuliang">{{item.amount}}</div>
                                        </div>
                            </div>
                </div>
                                  
                </div>
            <!-- 第二列 -->

                     <div style="display:flex;justify-content: space-around;margin-top:50px;">

                    <div style="width:600px;">
                 <!-- 排行榜3 -->
                            <div>
                                    <img src="../../static/images/huayuanlogo.png" alt="">
                            </div>
                           <div style="width:300px;" class="pai-center">
                                <span class="icon-left"></span>
                                    <h1 class="icon-center">客户采购排行榜</h1>
                                <span class="icon-right"></span>
                            </div>
                                        <div class="content-header"> 
                                                <div class="rank">排名</div>
                                                <div class="hot-product">客户</div>
                                                <div class="hot-productNo">客户编号</div>
                                                <div class="hot-amount">采购金额</div>
                                        </div>
                            <div class="brand-content-wrapper">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in tableData3" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{item.rowIndex}}
                                                     </span>
                                                </div>
                                                <div class="hot-product">{{item.customerName}}</div>
                                                <div class="hot-productNo">{{item.customerNo}}</div>
                                                <div class="hot-amount hot-shuliang">{{item.amount}}</div>
                                        </div>
                            </div>
                     </div>

                    <div style="width:600px;">
                 <!-- 排行榜4 -->
                            <div>
                                    <img src="../../static/images/huayuanlogo.png" alt="">
                            </div>
                           <div style="width:300px;" class="pai-center">
                                <span class="icon-left"></span>
                                    <h1 class="icon-center">综合人员销售排行榜</h1>
                                <span class="icon-right"></span>
                            </div>
                                        <div class="content-header"> 
                                                <div class="rank">排名</div>
                                              
                                                <div class="hot-productNo" style="flex:6">业务员编号</div>
                                                <div class="hot-amount">销售金额</div>
                                        </div>
                            <div class="brand-content-wrapper">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in tableData4" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{item.rowIndex}}
                                                     </span>
                                                </div>
                                                <div class="hot-productNo" style="flex:6">{{item.clerkNo}}</div>
                                                <div class="hot-amount hot-shuliang">{{item.amount}}</div>
                                        </div>
                            </div>
                    </div>

                      </div>

                      <!-- 第三列 -->

                         <div style="width:800px;margin:0 auto;margin-top:50px;">
                 <!-- 排行榜5 -->
                              <div>
                                    <img src="../../static/images/huayuanlogo.png" alt="">
                            </div>
                            <div style="width:300px;" class="pai-center">
                                <span class="icon-left"></span>
                                    <h1 class="icon-center">区域销售排行</h1>
                                <span class="icon-right"></span>
                            </div>
                                        <div class="content-header"> 
                                                <div class="rank">排名</div>
                                                <div class="hot-paihang">
                                                        <select v-model="difang" style="width:80px;" @change="getPaiming(difang)">
                                                          <option value="">请选择省份</option>
                                                          <option v-for="(item,index) in shengfen" :key="index" :value="item" v-text="item" ></option>
                                                        </select>
                                                </div>
                                                <div class="hot-paihang" @click="paixu('gongSi')">
                                                    <span>
                                                       公司/客户数
                                                    </span>
                                                    <img src="../../static/images/paixu2.png" class="imgsize" alt="" v-show="gongSi">
                                                    <img src="../../static/images/paixu3.png" class="imgsize" alt="" v-show="!gongSi">
                                                      
                                                </div>
                                                <div class="hot-paihang" @click="paixu('yaoFang')">
                                                    <span>
                                                      药房/客户数
                                                    </span>
                                                    <img src="../../static/images/paixu2.png" class="imgsize" alt="" v-show="yaoFang">
                                                     <img src="../../static/images/paixu3.png" class="imgsize" alt="" v-show="!yaoFang">
                                                </div>
                                                <div class="hot-paihang1" @click="paixu('yiLiaoJiGou')">
                                                    <span>
                                                     医疗机构/客户数
                                                    </span>
                                                    <img src="../../static/images/paixu2.png" class="imgsize" alt="" v-show="yiLiaoJiGou">
                                                     <img src="../../static/images/paixu3.png" class="imgsize" alt="" v-show="!yiLiaoJiGou">
                                                </div>
                                                <div class="hot-paihang" @click="paixu('qiTa')">
                                                    <span>
                                                     其他/客户数
                                                    </span>
                                                     <img src="../../static/images/paixu2.png" class="imgsize" alt="" v-show="qiTa">
                                                      <img src="../../static/images/paixu3.png" class="imgsize" alt="" v-show="!qiTa">
                                                </div>
                                                <div class="hot-paihang" @click="paixu('amount')">
                                                    <span>
                                                     合计
                                                    </span>
                                                    <img src="../../static/images/paixu2.png" class="imgsize" alt="" v-show="amount">
                                                    <img src="../../static/images/paixu3.png" class="imgsize" alt="" v-show="!amount">
                                                </div>
                                        </div>
                            <div v-if="searchList.length==0" class="brand-content-wrapper" style="height:500px;width:800px;">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in tableData5" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{index+1}}
                                                     </span>
                                                </div>
                                                <div class="hot-paihang">{{item.provinceName}}</div>
                                                <div class="hot-paihang">{{item.gongSi}}
                                                     
                                                           <span class="active_kan">
                                                               /{{item.gongSiCount}}
                                                           </span>

                                                </div>
                                                <div class="hot-paihang">{{item.yaoFang}}
                                                          
                                                          <span class="active_kan">
                                                                /{{item.yaoFangCount}}
                                                          </span>

                                                </div>
                                                <div class="hot-paihang1">{{item.yiLiaoJiGou}}
                                                           <span class="active_kan">
                                                                 /{{item.yiLiaoJiGouCount}}
                                                           </span>
                                                </div>
                                                <div class="hot-paihang">{{item.qiTa}}
                                                           <span class="active_kan">
                                                                 /{{item.qiTaCount}}
                                                           </span>
                                                </div>
                                                <div class="hot-paihang">{{item.amount}}</div>
                                        </div>
                            </div>
                            <div v-else class="brand-content-wrapper" style="height:500px;width:800px;">
                                        <div class="content-item" :class="{on:index%2==0,off:index%2!=0}" v-for="(item,index) in searchList" :key="index">
                                                <div class="rank rank-content">
                                                     <span>
                                                         Top
                                                         <br>
                                                         <br>
                                                     </span>
                                                     <span class="mr-1">
                                                        {{index+1}}
                                                     </span>
                                                </div>
                                                <div class="hot-paihang">{{item.provinceName}}</div>
                                                <div class="hot-paihang">{{item.gongSi}}</div>
                                                <div class="hot-paihang">{{item.yaoFang}}</div>
                                                <div class="hot-paihang1">{{item.yiLiaoJiGou}}</div>
                                                <div class="hot-paihang">{{item.qiTa}}</div>
                                                <div class="hot-paihang">{{item.amount}}</div>
                                        </div>
                            </div>
                           
                </div>

                                       
                </b-card-body>

                </b-card>
            </div>


                 
                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>


     </div>
</template>
<script>
import {mapState} from 'vuex'
import Loading from '../components/Loading.vue'
export default {
     data(){
          return{
              tableData1:[],
              tableData2:[],
              tableData3:[],
              tableData4:[],
              tableData5:[],
              DateType:'',
              show:1,
             isLoading: false,
             shengfen:[],
             difang:"",
             searchList:[],
             sortType: 'amount',
             gongSi: true,
             yaoFang: true,
             yiLiaoJiGou: true,
             qiTa: true,
             amount: true,
          }
      },
   filters:{
         
   },
    components:{
        Loading
    },
      methods:{

        paixu(type){
           this.sortType = type;
           if(type=="gongSi"){
               this.gongSi=false
           }
           else{
               this.gongSi=true
           }
            if(type=="yaoFang"){
               this.yaoFang=false
           }
           else{
               this.yaoFang=true
           }
            if(type=="yiLiaoJiGou"){
               this.yiLiaoJiGou=false
           }
           else{
               this.yiLiaoJiGou=true
           }
            if(type=="qiTa"){
               this.qiTa=false
           }
           else{
               this.qiTa=true
           }
            if(type=="amount"){
               this.amount=false
           }
           else{
               this.amount=true
           }
           
          
           this.tableData5.sort(this.compare(type));
           if(this.searchList.length>0){
               this.searchList.sort(this.compare(type));
           }
                
          },
          compare(attr) {
                return function(a,b){
                var val1 = a[attr];
                var val2 = b[attr];
                return val2 - val1;
                }
          },
          getPaiming(difang){
              const that= this
              that.searchList=[],
              that.tableData5.forEach((item,index)=>{
                 if(item.provinceName==difang){
                        that.searchList.push(that.tableData5[index])
                 }
              })
          },
          
          day(){
         this.show=1;
         this.drugrankmodel(1);
         this.factrankmodel(1);
         this.custrankmodel(1);
         this.clerkrankmodel(1);
         this.custanalysismodel(1);
          },
          mounth(){
         this.show=2;
         this.drugrankmodel(2);
         this.factrankmodel(2);
         this.custrankmodel(2);
         this.clerkrankmodel(2);
         this.custanalysismodel(2);
          },
          year(){
         this.show=3;
         this.drugrankmodel(3);
         this.factrankmodel(3);
         this.custrankmodel(3);
         this.clerkrankmodel(3);
         this.custanalysismodel(3);
          },
     
       drugrankmodel:async function(DateType){
        //    this.isLoading=true;
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'drugrankmodel',
          obj: JSON.stringify({
               DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.tableData1 = obj.rows;
                //   this.isLoading=false;
             }
        
       },
        factrankmodel:async function(DateType){
            //  this.isLoading=true;
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'factrankmodel',
          obj: JSON.stringify({
               DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.tableData2 = obj.rows;
                //   this.isLoading=false;
             }
        
       },
        custrankmodel:async function(DateType){
            //  this.isLoading=true;
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'custrankmodel',
          obj: JSON.stringify({
               DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.tableData3 = obj.rows;
                //   this.isLoading=false;
             }
        
       },
       clerkrankmodel:async function(DateType){
            // this.isLoading=true;
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'clerkrankmodel',
          obj: JSON.stringify({
               DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.tableData4 = obj.rows;
                //   this.isLoading=false;
             }
        
       },
       custanalysismodel:async function(DateType){
            // this.isLoading=true;
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'custanalysismodel',
          obj: JSON.stringify({
               DateType,

          })
        })
        // console.log(res)
        if (res.isok) {
                  const obj = res.data;
                  this.tableData5 = obj.rows;
                  const that= this
                  that.tableData5.forEach((item,index)=>{
                        that.shengfen.push(item.provinceName)
                  })
                //   this.isLoading=false;
                        // console.log(that.shengfen)
             }
        
       },
  
      },
     
      created(){
         this.drugrankmodel(1);
         this.factrankmodel(1);
         this.custrankmodel(1);
         this.clerkrankmodel(1);
         this.custanalysismodel(1);
      }
}
</script>
<style lang="less" scoped>

.brand-content-wrapper{
    width:600px;
    height:600px;
    overflow: auto;
    // border-top:5px solid #cd2525;
    // box-sizing: border-box;
}
.rank{
    display: inline-block;
    flex: 1;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
}
.content-header{
    height: 60px;
    background: #EFEFEF;
    font-size: 0;
    line-height: 30px;
    text-align: center;
    align-items: center;
    display: flex;
    font-weight:bold;
    border-top:5px solid #cd2525;
    box-sizing: border-box;
   
}
.hot-paihang{
    display: inline-block;
    display: flex;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    flex:2;
    text-align:center;
    justify-content: center;
    align-items: center;
}
.hot-paihang1{
    display: inline-block;
    display: flex;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    flex:3;
    text-align:center;
    justify-content: center;
    align-items: center;
}
.hot-product{
    display: inline-block;
    flex:4;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
}
.hot-productNo{
    display: inline-block;
    flex:2;
    height: 30px;
    line-height: 30px;
    font-size: 14px
}
.hot-amount{
    display: inline-block;
    flex:2;
    height: 30px;
    line-height: 30px;
    font-size: 14px
}
.content-item{
    align-items:center;
    display: flex;
    text-align: center;
    height:90px;
}
    .on {
        
        background: #fff;
        }
    .off {
        background: #EFEFEF;;
     
    }
   .activev{
      background:#cd2525;
      border-radius:3px;
}
h1{
    padding:0px;
    margin:0px;
}
.pai-center{
    display: inline-block;
    margin:0 auto;
    margin-bottom:20px;
     position: relative;
}
 .icon-center{
                       
                        display:block;
                        height: 40px;
                        background: #CD2525;
                        line-height: 40px;
                        color: #fff;
                        padding: 0 10px;
                        font-size: 18px;
                        margin-bottom:0px;
                      
    }
.icon-left{
    position: absolute;
    top:0px;
    left:-35px;
    display:block;
    background: url(../../static/images/left.png);
    background-size: cover;
    height: 44px;
    width: 36px;
    margin-right: -8px;
}
.icon-right{
     position: absolute;
    top:0px;
    right:-25px;
    display:block;
    background: url(../../static/images/right.png);
    background-size: cover;
    height: 44px;
    width: 36px;
    margin-right: -8px;
    margin-left:-8px;
}
.rank-content{
     display: inline-block;
    background-image: url(../../static/images/rank-icon.png);
    background-size: 100% 100%;
    width: 60px;
    height: 80px;
    line-height: 12px;
    color: #fff;
    font-size: 12px;
    padding-top: 20px;
    box-sizing: border-box;
    vertical-align: top;
    font-weight: 1000;
}
.hot-shuliang{
    height: 18px;
    width: 60px;
    font-size: 14px;
    font-weight: bolder;
    color: #C81723;
}
.imgsize{
    width:15px;
    height:15px;
    margin-left:5px;
}
 .active_kan{
      color:red;
 }
</style>




// WEBPACK FOOTER //
// src/pages/RankingList.vue